/** Route of the staff page that lists every user's and organization's subscription. */
export const ADMIN_SUBSCRIPTIONS_PATH = "/muggleTestV0/dashboard/admin/subscriptions";
